import React from 'react';

import { StyledLink, StyledTypography } from 'styles/common';

import { contactEmail } from 'constants/ProjectConstants';
import { UninstallIcon } from 'constants/icons';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const Item = ({ children, isTopItem = false }) => (
  <StyledTypography bottomGutter={2} topGutter={isTopItem ? 2 : 0}>
    {children}
  </StyledTypography>
);

const UninstallSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <UninstallIcon size="fixed16px" />
      </Icon>
      Un-Installation Steps
    </FormHeading>
    <Separator />
    <BodyContainer>
      <Item isTopItem>
        Please email to{' '}
        <StyledLink display="inline-block" href={`mailto:${contactEmail}`}>
          {contactEmail}
        </StyledLink>{' '}
        to unlink the associated HRIS account
      </Item>
    </BodyContainer>
  </FormContainer>
);

export default UninstallSection;
